import React, { useState, useEffect } from "react";
import axios from "axios";
import DashboardWidget from "./components/DashboardWidget";
import StatisticsCard from "./components/StatisticsCard";
import { API_URL } from "../../config";

const Dashboard = () => {
  const [graphData, setGraphData] = useState({
    weeklyLabels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    weeklyTotalVisitor: [],
    weeklyVipVisitor: [],
    weeklyPoliticallyActiveVisitor: [],
    weeklyVisitorWithProblem: [],
    monthlyLabels: [],
    monthlyData: [],
  });

  const [latestStats, setLatestStats] = useState({
    total: 0,
    vip: 0,
    politically: 0,
    problem: 0,
  });

  useEffect(() => {
    const fetchVisitorData = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${API_URL}getSevendayrecord`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (response.data.status === "success") {
          const data = response.data.data;

          setGraphData({
            weeklyLabels: Object.keys(data.total_visitor || {}),
            weeklyTotalVisitor: Object.values(data.total_visitor || {}),
            weeklyVipVisitor: Object.values(data.vip_visitor || {}),
            weeklyPoliticallyActiveVisitor: Object.values(
              data.politically_active_visitor || {}
            ),
            weeklyVisitorWithProblem: Object.values(
              data.visitor_with_problem || {}
            ),
            monthlyLabels: Object.keys(data.Monthly_record || {}),
            monthlyData: Object.values(data.Monthly_record || {}),
          });

          setLatestStats({
            total: data.total || 0,
            vip: data.vip || 0,
            politically: data.politically || 0,
            problem: data.problem || 0,
          });
        } else {
          console.error("Failed to fetch data:", response.data.message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchVisitorData();
  }, []);

  return (
    <div className="p-4">
      {/* Dashboard Widgets */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        <DashboardWidget
          label="Total Visitors"
          value={latestStats.total || 0}
          percentage="2%"
          percentageType="up"
          borderColor="border-blue-400"
          bgColor="bg-blue-200"
          textColor="text-blue-600"
          graphData={{
            labels: graphData.weeklyLabels,
            data: graphData.weeklyTotalVisitor,
            barColor: "#63b3ed",
          }}
        />
        <DashboardWidget
          label="VIP Visitors"
          value={latestStats.vip || 0}
          percentage="1%"
          percentageType="down"
          borderColor="border-purple-500"
          bgColor="bg-purple-200"
          textColor="text-purple-500"
          graphData={{
            labels: graphData.weeklyLabels,
            data: graphData.weeklyVipVisitor,
            barColor: "#6B46C1",
          }}
        />
        <DashboardWidget
          label="Politically Active Visitors"
          value={latestStats.politically || 0}
          percentage="3%"
          percentageType="up"
          borderColor="border-green-400"
          bgColor="bg-green-200"
          textColor="text-green-600"
          graphData={{
            labels: graphData.weeklyLabels,
            data: graphData.weeklyPoliticallyActiveVisitor,
            barColor: "#48bb78",
          }}
        />
        <DashboardWidget
          label="Visitors With Problems"
          value={latestStats.problem || 0}
          percentage="2%"
          percentageType="down"
          borderColor="border-red-400"
          bgColor="bg-red-200"
          textColor="text-red-600"
          graphData={{
            labels: graphData.weeklyLabels,
            data: graphData.weeklyVisitorWithProblem,
            barColor: "#f56565",
          }}
        />
      </div>

      {/* Statistics Section */}
      <StatisticsCard
        title="Monthly Visitor Statistics"
        // totalVisitors={latestStats.total}
        graphData={{
          labels: graphData.monthlyLabels,
          data: graphData.monthlyData,
          barColor: "#a0aec0",
        }}
      />
    </div>
  );
};

export default Dashboard;
